"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Architect;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Architect() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "45px",
    height: "45px",
    viewBox: "0 0 42.21 42.21",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "architect-linear-gradient",
        x1: "4.84",
        y1: "4.84",
        x2: "37.09",
        y2: "37.09",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.16",
          stopColor: "#66c39e"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#2a875d"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "architect-linear-gradient-2",
        x1: "20.77",
        y1: "36.21",
        x2: "21.42",
        y2: "6.9",
        gradientTransform: "translate(21.11 -8.74) rotate(45)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#c9e6d3"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.7",
          stopColor: "#fff"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "architect-linear-gradient-3",
        x1: "21.08",
        y1: "12.84",
        x2: "21.08",
        y2: "26.19",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#66c39e"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.92",
          stopColor: "#2a875d"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      style: {
        isolation: 'isolate'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Layer_2",
        "data-name": "Layer 2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Layer_1-2",
          "data-name": "Layer 1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M36.16,42.21H6.05a6.05,6.05,0,0,1-6-6.05V6.05A6.05,6.05,0,0,1,6.05,0H36.16a6.05,6.05,0,0,1,6.05,6.05V36.16A6.05,6.05,0,0,1,36.16,42.21ZM6.05,1.4A4.65,4.65,0,0,0,1.4,6.05V36.16a4.65,4.65,0,0,0,4.65,4.65H36.16a4.65,4.65,0,0,0,4.65-4.65V6.05A4.65,4.65,0,0,0,36.16,1.4Z",
            style: {
              fill: '#423f3f',
              isolation: 'isolate'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "0.7",
            y: "0.7",
            width: "40.81",
            height: "40.81",
            rx: "5.35",
            style: {
              fill: 'url(#architect-linear-gradient)',
              isolation: 'isolate'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M36.16,42.21H6.05a6.05,6.05,0,0,1-6-6.05V6.05A6.05,6.05,0,0,1,6.05,0H36.16a6.05,6.05,0,0,1,6.05,6.05V36.16A6.05,6.05,0,0,1,36.16,42.21ZM6.05,1.4A4.65,4.65,0,0,0,1.4,6.05V36.16a4.65,4.65,0,0,0,4.65,4.65H36.16a4.65,4.65,0,0,0,4.65-4.65V6.05A4.65,4.65,0,0,0,36.16,1.4Z",
            style: {
              fill: '#a9d8b7',
              isolation: 'isolate'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("image", {
            width: "165",
            height: "165",
            transform: "translate(2.08 1.99) scale(0.24)",
            xlinkHref: "data:image/png;base64,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",
            style: {
              opacity: '.38',
              mixBlendMode: 'multiply'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "8.3",
            y: "8.3",
            width: "25.61",
            height: "25.61",
            rx: "1.46",
            transform: "translate(-8.74 21.11) rotate(-45)",
            style: {
              fill: 'url(#architect-linear-gradient-2)'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M21.11,39.31a2.18,2.18,0,0,1-1.53-.63h0l-16-16a2.16,2.16,0,0,1,0-3.05l16-16a2.16,2.16,0,0,1,3.05,0l16.05,16a2.16,2.16,0,0,1,0,3.05l-16,16.05A2.18,2.18,0,0,1,21.11,39.31Zm0-35a.79.79,0,0,0-.54.22l-16,16.05a.76.76,0,0,0,0,1.07l16.05,16a.79.79,0,0,0,1.07,0l16-16a.77.77,0,0,0,0-1.07l-16-16A.79.79,0,0,0,21.11,4.3Z",
            style: {
              fill: '#fff',
              isolation: 'isolate'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M23.05,13H19.5L14.16,28.37H17.9l1-3.12h4.79l1,3.12h3.82Zm-1.8,4.41c.1.38.2.77.3,1.07l1.17,3.78H19.77l1.17-3.78C21,18.22,21.15,17.83,21.25,17.45Z",
            style: {
              fill: '#2a875d'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M19.51,13h3.08l5.16,14.65h-3.1l-1-3.11H18.39l-1,3.11h-3Zm-.43,9.26H23l-1.31-4.22c-.24-.77-.59-2.25-.59-2.25h0s-.37,1.48-.62,2.25Z",
            style: {
              fill: 'url(#architect-linear-gradient-3)'
            }
          })]
        })
      })
    })]
  });
}